'use client';

import type { CSSProperties, ReactElement } from 'react';
import {
  ACCENT,
  COMPACT_INSET,
  COMPACT_POINT_OPACITY,
  COMPACT_POINT_RADIUS,
  COMPACT_VIEW_SIZE,
  MIDLINE_STROKE,
  MIDLINE_WIDTH,
  PLOT_BORDER,
  PLOT_BORDER_WIDTH,
} from './quadrant-constants';
import type { QuadrantPoint } from './quadrant-types';

const COMPACT_VIEW_BOX = `0 0 ${COMPACT_VIEW_SIZE} ${COMPACT_VIEW_SIZE}`;
const COMPACT_SVG_SIZE = '100%';
const COMPACT_BOX_SIZE = COMPACT_VIEW_SIZE - COMPACT_INSET * 2;
const COMPACT_MID = COMPACT_VIEW_SIZE / 2;

const compactSvgStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  display: 'block',
};

interface QuadrantCompactPreviewProps {
  points: ReadonlyArray<QuadrantPoint>;
}

export function QuadrantCompactPreview({
  points,
}: QuadrantCompactPreviewProps): ReactElement {

  return (
      <svg
        viewBox={COMPACT_VIEW_BOX}
        width={COMPACT_SVG_SIZE}
        height={COMPACT_SVG_SIZE}
        style={compactSvgStyle}
      >
        <rect
          x={COMPACT_INSET}
          y={COMPACT_INSET}
          width={COMPACT_BOX_SIZE}
          height={COMPACT_BOX_SIZE}
          fill={PLOT_BORDER}
          fillOpacity={0}
          stroke={PLOT_BORDER}
          strokeWidth={PLOT_BORDER_WIDTH}
        />
        <line
          x1={COMPACT_MID}
          y1={COMPACT_INSET}
          x2={COMPACT_MID}
          y2={COMPACT_VIEW_SIZE - COMPACT_INSET}
          stroke={MIDLINE_STROKE}
          strokeWidth={MIDLINE_WIDTH}
        />
        <line
          x1={COMPACT_INSET}
          y1={COMPACT_MID}
          x2={COMPACT_VIEW_SIZE - COMPACT_INSET}
          y2={COMPACT_MID}
          stroke={MIDLINE_STROKE}
          strokeWidth={MIDLINE_WIDTH}
        />
        {points.map((point, index) => (
          <circle
            key={`${index}-${point.label}`}
            cx={COMPACT_INSET + point.x * COMPACT_BOX_SIZE}
            cy={COMPACT_INSET + (1 - point.y) * COMPACT_BOX_SIZE}
            r={COMPACT_POINT_RADIUS}
            fill={ACCENT}
            opacity={COMPACT_POINT_OPACITY}
          />
        ))}
      </svg>
  );
}
